// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconElectricDividerRight: React.FC<{ width?: number; height?: number }> = ({ height = 16 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="338" height="16" viewBox="0 0 338 16">
            <polyline
                fill="none"
                stroke="currentColor"
                points="0 8.05 50.041 8 54.091 1 62.191 15 70.292 1 78.392 15 82.413 8.05 338 8.05"
            />
        </svg>
    );
};

export default React.memo(IconElectricDividerRight);
